export default "__VITE_ASSET__CEk4RVTP__"